import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIcon, LazyIconCSS, LazyButton, LazyColumn, LazyDataTable, LazyAccordion, LazyAccordionPanel, LazyTabView, LazyTabs, LazyTabList, LazyTab, LazyTabPanels, LazyTabPanel, LazyDialog, LazyToast, LazyProgressBar, LazyProgressSpinner } from '#components'
const lazyGlobalComponents = [
  ["Icon", LazyIcon],
["IconCSS", LazyIconCSS],
["Button", LazyButton],
["Column", LazyColumn],
["DataTable", LazyDataTable],
["Accordion", LazyAccordion],
["AccordionPanel", LazyAccordionPanel],
["TabView", LazyTabView],
["Tabs", LazyTabs],
["TabList", LazyTabList],
["Tab", LazyTab],
["TabPanels", LazyTabPanels],
["TabPanel", LazyTabPanel],
["Dialog", LazyDialog],
["Toast", LazyToast],
["ProgressBar", LazyProgressBar],
["ProgressSpinner", LazyProgressSpinner],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
